import { Box, Typography, Link } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TkButton from "../../components/atoms/TkButton";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkTitle from "../../components/atoms/TkTitle";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_REC002_Response } from "../../type/apiType";
import { changeAmountFormat } from "../../utils/useTools";
import "./_style.scss";
import { httpAPI_REC002, httpAPI_REC009 } from "./api/request";
import { fakeTableList, headList } from "./parts";
import _ from "lodash";

/**
 * (SCR0217)_SCRW160005_請求詳細
 * @return (SCR0217)_SCRW160005_請求詳細
 */
const SCRW160005 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const applyId = businessState.job_13?.applyId;
  const contractorNo =
    businessState.job_13?.contractorNo ?? businessState.job_83?.contractorNo;
  const invoiceId =
    businessState.job_13?.demanderId ?? businessState.job_83?.demanderId;
  const [receiptDetail, setReceiptDetail] = useState<IAPI_REC002_Response>({
    resultCd: "", // 結果コード
    invoiceId: 0, // 請求ID
    depositStatus: "", // 入金状況
    overPaymentAmount: 0, // 過納額
    invoiceClass: "", // 区分
    contractorNo: "", // 番号請求先番号
    contractorName: "", // 請求先名称
    invoiceAmt: 0, // 金額
    billingDate: "", // 請求日
    depositHistoryList: [], // 入金履歴リスト
    fileList: [], // ファイルリスト
  });
  const [stateInfoList, setStateInfoList] = useState(
    _.cloneDeep(fakeTableList)
  );
  const [fileList, setFileList] = useState<any[]>([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInit = async () => {
    try {
      const res = await httpAPI_REC002({
        contractorNo: contractorNo,
        invoiceId: invoiceId,
      });

      if (res.resultCd === "I0000") {
        setState({ ...state, errorMsgId: "" });
        setReceiptDetail(res);

        let resArr = stateInfoList;

        resArr.find((item) => item.keyword === "invoiceClass")!.text =
          res.invoiceClass;
        resArr.find((item) => item.keyword === "contractorName")!.text =
          res.contractorNo && res.contractorName
            ? (res.contractorNo ?? "") + ":" + (res.contractorName ?? "")
            : "";
        resArr.find((item) => item.keyword === "invoiceAmt")!.text =
          changeAmountFormat(res.invoiceAmt ?? 0) + "円";
        resArr.find((item) => item.keyword === "billingDate")!.text =
          res.billingDate;

        setStateInfoList([...resArr]);

        setFileList(formatFileList(res.fileList ?? []));
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const formatFileList = (fileList: any[]) => {
    return fileList.map((item) => {
      return [
        {
          children: (
            <TkDownloadLink
              dataname={item.formName}
              base64filedata={item.file}
              downloadBase64={true}
            />
          ),
          align: "left",
          width: "40%",
        },
        {
          children: item.issueDocumentNo,
          align: "left",
        },
        {
          children: item.issueDate,
          align: "left",
        },
      ];
    });
  };

  // 入金完了として扱う
  const handleUpdateDepositStatus = async () => {
    try {
      // 入金状況更新API
      const res = await httpAPI_REC009({
        invoiceId: invoiceId,
        status: "2",
      });
      if (res.resultCd === "I0000") {
        setState({ ...state, errorMsgId: "" });
        navigate("/SCRW160003");
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
        return;
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleClickDepositId = (data: any) => {
    setBusinessState({
      ...businessState,
      paymentManagement: {
        ...businessState.paymentManagement,
        depositId: data.depositId,
        depositNo: data.depositNo,
        depositDate: data.depositDate,
        depositAmt: data.depositAmt,
        fromRequesterName: data.fromRequesterName,
        fromBankName: data.fromBankName,
        fromBranchName: data.fromBranchName,
        depositKbn: data.depositKbn,
        invoiceId: receiptDetail.invoiceId,
        billingDate: receiptDetail.billingDate,
        billingContractorNo: receiptDetail.contractorNo,
        billingContractorName: receiptDetail.contractorName,
        billingKbn: receiptDetail.invoiceClass,
        billingAmt: receiptDetail.invoiceAmt,
        sortingStatus: data.sortingStatus,
      },
    });
    navigate("/SCRW160002");
  };

  return (
    <Box data-testid="SCRW160005PageForTest" className="SCRW160005">
      <Box className="flexStart">
        <Typography>請求ID</Typography>
        <Typography>{invoiceId}</Typography>
      </Box>
      <Box className="flexStart">
        <Typography>入金状況</Typography>
        <Box className="status">
          <Typography>{receiptDetail.depositStatus}</Typography>
          <Typography>
            {receiptDetail.overPaymentAmount
              ? `( +${changeAmountFormat(receiptDetail.overPaymentAmount)})`
              : ""}
          </Typography>
        </Box>
        <TkButton onClick={() => setOpen(true)}>入金完了として扱う</TkButton>
      </Box>
      <TkFakeTable list={stateInfoList} ruleSchema={{}} showButton={false} />

      <TkTitle size="small">入金履歴</TkTitle>
      {receiptDetail.depositHistoryList?.map((item, index) => (
        <Box key={index} className="map">
          <Typography>{item.depositDate}</Typography>
          <Typography>
            入金ID：
            <Link onClick={() => handleClickDepositId(item)}>
              {item.depositId}
            </Link>
          </Typography>
          <Typography>
            入金額：{changeAmountFormat(item.depositAmt ?? "")} 円
          </Typography>
        </Box>
      ))}

      <TkTitle size="small">関連帳票（機構登録）</TkTitle>
      <TkTableWithNoLine headList={headList} bodyList={fileList} />

      <Box className="center">
        <TkBackButton useBackParam navigateParam={{ applyId }} />
      </Box>

      <TkMessageDialog
        open={open}
        onClose={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        title="入金完了として扱う"
        contextText="　入金完了に更新します。よろしいですか？"
        onOky={handleUpdateDepositStatus}
      />
    </Box>
  );
};

export default SCRW160005;
